import {
  MAX_TWO_DECIMALS_REGEX,
  numberErrorMessage,
  requiredErrorMessage,
} from 'constants/constants';
import { FarmBoxCommodityDestribution } from 'models/FarmBoxCommodityDestribution/farmBoxCommodityDestribution.model';
import * as Yup from 'yup';

export interface TestContextExtended {
  from: {
    value: FarmBoxCommodityDestribution;
  }[];
}
const validationSchemaForCommodityDestribution = Yup.object().shape({
  routes: Yup.array().of(
    Yup.object().shape({
      quantity: Yup.number()
        .required(requiredErrorMessage)
        .min(1, 'Quantity must be at least 1')
        .typeError(numberErrorMessage)
        .test(
          'decimal-precision',
          'Wet weight must have at most 2 decimal places',
          value => !value || MAX_TWO_DECIMALS_REGEX.test(value.toString())
        )
        .test(
          'total-quantity-match',
          'Sum of quantities must equal totalQuantity',
          function () {
            const formValues = (this as Yup.TestContext & TestContextExtended)
              .from[1].value;
            const totalQuantity = Number(formValues.totalQuantity);
            const desiredRoutes = formValues?.routes?.filter(
              value => value?.quantity !== null || undefined
            );
            const sumQuantity =
              desiredRoutes?.reduce(
                (sum, route) => sum + Number(route?.quantity),
                0
              ) || 0;
            return sumQuantity === totalQuantity;
          }
        ),
      addressLabel: Yup.string().required(requiredErrorMessage),
    })
  ),
});

export default validationSchemaForCommodityDestribution;
